<div *ngIf="!hidden" class="componentWrapper" id="{{component.id}}">
    <mat-form-field appearance="{{appearance}}" [ngClass]="{'stretchToFit': hasOptionValue(component, 'isFitScreen', true)}">
        <mat-label>{{label}}</mat-label>
        <input [formControl]="formControl" [placeholder]="label" [required]="isRequired" matInput type="text" [readonly]="readonly">
        <!--   [ngStyle]="hasOptionValue(component, 'stretchToFit', true) && {'display': 'inline-block'}"
                     <div [ngStyle]="isHidden(subcomponent) && {'display': 'none'}">ABC</div>-->
<!--        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">-->
<!--            <mat-icon>close</mat-icon>-->
<!--        </button>-->
<!--        <mat-hint align="start"><strong>Don't disclose personal info</strong> </mat-hint>-->
<!--        <mat-hint *ngIf="hasComponentValidatorKey('maxLength')" align="end">{{formControl.value.length}} / {{getComponentValidatorByKey('maxLength')}}</mat-hint>-->
        <mat-error *ngIf="formControl.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>
</div>
